import { openDialog } from '@/components/basic-components/dialog/create-dialog';
import Loading from './loading.vue';
import Confirm from './confirm.vue';
import GoogleMapDialog from './google-map-dialog.vue';
import type { ConfirmModalProps } from './confirm-types';
import type { GoogleMapDialogProps } from './google-map-dialog-types';
import CreateAccount from './create-account.vue';
import InterviewChannel from './interview-channel.vue';
import type { InterviewChannelModalProps } from './interview-channel-types';
import CreateJob from './create-job.vue';
import JobApplicationDialog from './job-application-dialog.vue';
import type { JobApplicationDialogProps } from './job-application-dialog-types';
import NoAccessPermission from './no-access-permission.vue';
import type { NoAccessPermissionModalProps } from './no-access-permission-types';
import UpdateEmail from './update-email.vue';
import UpdatePassword from './update-password.vue';
import ResumeResultDialog from './resume-result-dialog.vue';
import type { ResumeResultDialogProps } from './resume-result-dialog-types';
import OfferResultDialog from './offer-result-dialog.vue';
import type { OfferResultDialogProps } from './offer-result-dialog-types';
import TerminateInterviewDialog from './terminate-interview-dialog.vue';
import type { TerminateInterviewDialogProps } from './terminate-interview-dialog-types';
import Reject from './reject.vue';
import Accept from './accept.vue';
import type { RejectDialogProps } from './reject-types';
import type { AcceptDialogProps } from './accept-types';
import EditRemarkDialog from './edit-remark-dialog.vue';
import type { EditRemarkDialogProps } from './edit-remark-dialog-types';
import ChangeOwnerDialog from './change-owner-dialog.vue';
import type { ChangeOwnerDialogProps } from './change-owner-dialog-types';
import ScheduleInterviewDialog from './schedule-interview-dialog.vue';
import type { ScheduleInterviewDialogProps } from './schedule-interview-dialog-types';
import JoinDateDialog from './join-date-dialog.vue';
import type { JoinDateDialogProps } from './join-date-dialog-types';
import ConfirmJoinDialog from './confirm-join-dialog.vue';
import type { ConfirmJoinDialogProps } from './confirm-join-dialog-types';
import EditMessageDialog from './edit-message-dialog.vue';
import type { EditMessageDialogProps } from './edit-message-dialog-types';
import AddCandidateDialog from './add-candidate-dialog.vue';
import type { AddCandidateDialogProps } from './add-candidate-dialog-types';
import AiParseResidenceCardDialog from './ai-parse-residence-card-dialog.vue';
import type { AiParseResidenceCardDialogProps } from './ai-parse-residence-card-dialog-types';
import OpenToAgent from './open-to-agent.vue';
import BatchOpenToAgent from './batch-open-to-agent.vue';
import AiScoreDialog from './ai-score-dialog.vue';
import type { AiScoreDialogProps } from './ai-score-dialog-types';
import NotifyRecipientDialog from './notify-recipient-dialog.vue';
import type { NotifyRecipientDialogProps } from './notify-recipient-dialog-types';
import AnnouncementDialog from './announcement-dialog.vue';
import type { AnnouncementDialogProps } from './announcement-dialog-types';
import FileConfirmDialog from './file-confirm-dialog.vue';
import type { FileConfirmDialogProps } from './file-confirm-dialog-types';
import ContactDialog from './contact-dialog.vue';
import type { ContactDialogProps } from './contact-dialog-types';

export function openLoadingModal(props: any) {
  const options = {
    props: props,
  }
  return openDialog(Loading, options)
}

export function openConfirmModal(props: ConfirmModalProps) {
  const options = {
    props: props,
    rootProps: {
      zIndex: 3000,
    }
  }
  return openDialog(Confirm, options)
}

export function openGoogleMapDialog(props?: GoogleMapDialogProps) {
  const options = {
    props: props || {},
    rootProps: {
      zIndex: 3001,
    }
  }
  return openDialog(GoogleMapDialog, options)
}
export function openCreateAccountModal(props?: {
  title?: string;
  username?: string;
  email?: string;
  department?: string;
  roleId?: number;
  id?: string | number;
}) {
  const options = {
    props: props || {},
  }
  return openDialog(CreateAccount, options)
}

export function openInterviewChannelModal(props?: InterviewChannelModalProps) {
  const options = {
    props: props || {},
  }
  return openDialog(InterviewChannel, options)
}

export function openCreateJobModal() {
  const options = {
    props: {},
  }
  return openDialog(CreateJob, options)
}

export function openJobApplicationDialog(props?: JobApplicationDialogProps) {
  const options = {
    props: props || {},
  }
  return openDialog(JobApplicationDialog, options)
}

export function openNoAccessPermissionModal(props?: NoAccessPermissionModalProps) {
  const options = {
    props: props || {},
  }
  return openDialog(NoAccessPermission, options)
}
export function openUpdateEmailModal(props?: {
  initialEmail?: string;
}) {
  const options = {
    props: props || {},
  }
  return openDialog(UpdateEmail, options)
}
export function openUpdatePasswordModal(props?: {
  initialOldPassword?: string;
}) {
  const options = {
    props: props || {},
  }
  return openDialog(UpdatePassword, options)
}

export function openResumeResultDialog(props?: ResumeResultDialogProps) {
  const options = {
    props: props || {},
  }
  return openDialog(ResumeResultDialog, options)
}

export function openTerminateInterviewDialog(props: TerminateInterviewDialogProps) {
  const options = {
    props: props,
  }
  return openDialog(TerminateInterviewDialog, options)
}

export function openRejectModal(props: RejectDialogProps) {
  const options = {
    props: props,
  }
  return openDialog(Reject, options)
}

export function openAcceptModal(props: AcceptDialogProps) {
  const options = {
    props: props,
  }
  return openDialog(Accept, options)
}

export function openEditRemarkDialog(props: EditRemarkDialogProps) {
  const options = {
    props: props,
  }
  return openDialog(EditRemarkDialog, options)
}

export function openChangeOwnerDialog(props: ChangeOwnerDialogProps) {
  const options = {
    props: props,
  }
  return openDialog(ChangeOwnerDialog, options)
}

export function openScheduleInterviewDialog(props: ScheduleInterviewDialogProps) {
  const options = {
    props: props,
  }
  return openDialog(ScheduleInterviewDialog, options)
}

export function openOfferResultDialog(props: OfferResultDialogProps) {
  const options = {
    props: props,
  }
  return openDialog(OfferResultDialog, options)
}

export function openJoinDateDialog(props: JoinDateDialogProps) {
  const options = {
    props: props,
  }
  return openDialog(JoinDateDialog, options)
}

export function openConfirmJoinDialog(props: ConfirmJoinDialogProps) {
  const options = {
    props: props,
  }
  return openDialog(ConfirmJoinDialog, options)
}

export function openEditMessageDialog(props: EditMessageDialogProps) {
  const options = {
    props: props,
  }
  return openDialog(EditMessageDialog, options)
}

export function openAddCandidateDialog(props?: AddCandidateDialogProps) {
  const options = {
    props: props || {},
    rootProps: {
      modalClose: false, // 禁用点击遮罩层关闭，防止文件选择器取消时误关闭弹窗
    }
  }
  return openDialog(AddCandidateDialog, options)
}

export function openAiParseResidenceCardDialog(props?: AiParseResidenceCardDialogProps) {
  const options = {
    props: props || {},
    rootProps: {
      modalClose: false, // 禁用点击遮罩层关闭，防止文件选择器取消时误关闭弹窗
    }
  }
  return openDialog(AiParseResidenceCardDialog, options)
}

export function openOpenToAgentDialog(props?: any) {
  const options = {
    props: props || {},
  }
  return openDialog(OpenToAgent, options)
}
export function openBatchOpenToAgentDialog(props?: any) {
  const options = {
    props: props || {},
  }
  return openDialog(BatchOpenToAgent, options)
}

export function openAiScoreDialog(props: AiScoreDialogProps) {
  const options = {
    props: props,
  }
  return openDialog(AiScoreDialog, options)
}

export function openNotifyRecipientDialog(props: NotifyRecipientDialogProps) {
  const options = {
    props: props,
  }
  return openDialog(NotifyRecipientDialog, options)
}

export function openAnnouncementDialog(props: AnnouncementDialogProps) {
  const options = {
    props: props,
    rootProps: {
      zIndex: 3000,
    }
  }
  return openDialog(AnnouncementDialog, options)
}

export function openContactDialog(props?: ContactDialogProps) {
  const options = {
    props: props || {},
  }
  return openDialog(ContactDialog, options)
}

export function openFileConfirmDialog(props: FileConfirmDialogProps) {
  const options = {
    props: props,
    rootProps: {
      modalClose: false,
    }
  }
  return openDialog(FileConfirmDialog, options)
}

export { };
